import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

/**
 * GET /team/cash-flow/to-do/summary — flat overdue-plus-current-period list
 * for the dashboard card. `meta.total` reflects the full matching set even
 * when `limit` truncates `data`, so the badge/footer count never disagrees
 * with what a wider view (My Todos) would show.
 */
export default function useGetTodoSummary({ limit, enabled = true } = {}) {
  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/to-do/summary', {
      params: { limit },
    })
    return response.data
  }

  return useQuery({
    queryKey: ['todo-summary', { limit }],
    queryFn: fetchData,
    enabled,
  })
}
